import { Box, Button, Card, CardBody, CardHeader, Container, Flex, FormControl, FormLabel, Input, Stack, useStatStyles, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { LoginToken } from "../service/api/token";


export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const errToast = useToast()

    const isUserError = username === ''
    const isPasswError = password === ''

    const callLoginApi = async () => {
        const user = {
            username: username,
            password: password

        };

        const { status, resp } = await LoginToken(user);
        if (status === 0) {
            localStorage.clear();
            localStorage.setItem('access_token', resp.access);
            localStorage.setItem('refresh_token', resp.refresh);
            window.location.href = '/'
        } else if (status === 1) {
            errToast({
                title: "Login failed",
                description: resp,
                status: "error",
                duration: 5000,
                isClosable: true
            });
        };
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        callLoginApi();

    }



    return (
        <Container
            h="100vh"
            centerContent
            alignContent='center'
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"

                margin={5}
                p={8}
                borderWidth={1}
                borderRadius={8}
            >
                <Card>
                    <CardHeader>
                        Login
                    </CardHeader>

                    <CardBody>
                        <form onSubmit={handleSubmit}>
                            <Stack direction="column">

                                <FormControl>
                                    <FormLabel>Username
                                    </FormLabel>
                                    <Input
                                        onChange={event => setUsername(event.target.value)}
                                        type="text"
                                        placeholder="Enter username" />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Password
                                    </FormLabel>
                                    <Input
                                        onChange={event => setPassword(event.target.value)}
                                        type='password'
                                        placeholder="Enter Password" />
                                </FormControl>
                                <Button
                                    type="submit"
                                    colorScheme="teal"
                                    mt={4} >Login</Button>
                            </Stack>
                        </form>
                    </CardBody>
                </Card>
            </Box>
        </Container>

    )
}